import * as c from './constants.js';
import { hasIframeChild, applyExclusionRules } from './utils.js';

export const getLimitMarkers = () => document.querySelectorAll(`.${c.LIMIT_MARKER}`);

/**
 * Get paragraph elements containig iframe
 */
export const getIframeElements = () => [...document.querySelectorAll('p')]
  .filter((p) => hasIframeChild(p));

/**
 * Create selector string to get blocking elements
 * @param {Array.<string>} blockingElementsTags
 */
export const getBlockingElementsSelector = (blockingElementsTags) => blockingElementsTags
  .map((element) => `.${c.EDITOR_CONTENT} > ${element}`)
  .join();

/**
 * Get elements blocking ad slots
 */
export const getBlockingElements = (limitMarkers) => [...document
  .querySelectorAll(getBlockingElementsSelector(c.BLOCKING_ELEMENTS_TAGS)), ...getIframeElements()]
  .filter(applyExclusionRules(limitMarkers));

/**
 * Get text nodes depending on the content type
 * @param {('recipe' | 'longForm')} contentType
 */
export const getTextNodes = (contentType) => {
  if (contentType === 'recipe') {
    return [...document
      .querySelector(`.${c.RECIPE_STEPS}`)
      .querySelectorAll(`p, .${c.STEP_HEADING}`)].slice(0, -1);
  }

  return [...document
    .querySelectorAll(c.LONG_FORM_PARAGRAPHS)].slice(1, -1);
};
